import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67425870"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择组织")
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择部门")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("选择人员")
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("自选一个人")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("自选多个人")
const _hoisted_10 = { key: 4 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发起人的第 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 级主管", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 直接主管为 第 1 级主管", -1))
const _hoisted_14 = { key: 5 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("直到最上层主管")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("不超过发起人的")
const _hoisted_17 = {
  key: 0,
  class: "approve-end-leave"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "第 ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 级主管", -1))
const _hoisted_20 = { key: 6 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发起人的第 ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 级区域负责人", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 运维部区域负责人进行审批，通过发起人匹配区域负责人", -1))
const _hoisted_24 = { key: 7 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备所属组织的第 ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 级区域负责人", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 0级表示上级条线所有区域负责人", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 运维部区域负责人进行审批，通过设备所属组织匹配区域负责人", -1))
const _hoisted_29 = { key: 8 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备所属组织的第 ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 级区域处理人", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 0级表示上级条线所有区域处理人", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 运维部区域处理人进行处理，通过设备所属组织匹配区域处理人", -1))
const _hoisted_34 = { key: 9 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所选组织的第 ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 级区域负责人", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 0级表示上级条线所有区域负责人", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 运维部区域负责人进行审批，通过所选组织匹配区域负责人", -1))
const _hoisted_39 = { key: 10 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所选组织的第 ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 级区域处理人", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 0级表示上级条线所有区域处理人", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eff","font-size":"small","padding-left":"5px"} }, "👉 运维部区域处理人进行处理，通过所选组织匹配区域处理人", -1))
const _hoisted_44 = { key: 11 }
const _hoisted_45 = { key: 12 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-desc" }, "发起人自己作为审批人进行审批", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createTextVNode("自动通过")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("自动驳回")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("转交审批管理员")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("转交到指定人员")
const _hoisted_52 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_53 = /*#__PURE__*/_createTextVNode("选择人员")
const _hoisted_54 = { key: 0 }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("会签 （按选择顺序审批，每个人必须同意）")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("会签（可同时审批，每个人必须同意）")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("或签（有一人同意即可）")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("高级设置")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("自动通过")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("自动驳回")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("发送提醒")
const _hoisted_62 = {
  key: 0,
  class: "w-100"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#409eef","font-size":"small"} }, "默认提醒当前审批人", -1))
const _hoisted_64 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" 每隔 ")
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" 小时提醒一次 ")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("直接结束流程")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("驳回到上级审批节点")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("驳回到指定节点")
const _hoisted_70 = {
  key: 0,
  class: "w-100"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "指定节点:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_picker_items = _resolveComponent("picker-items")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_org_picker = _resolveComponent("org-picker")!
  const _component_dept_picker = _resolveComponent("dept-picker")!
  const _component_post_picker = _resolveComponent("post-picker")!
  const _component_user_picker = _resolveComponent("user-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      "label-position": "top",
      "label-width": "90px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "⚙ 选择审批对象",
          prop: "text",
          class: "user-type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.nodeProps.assignedType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nodeProps.assignedType) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalTypes, (t) => {
                  return (_openBlock(), _createBlock(_component_el_radio, {
                    label: t.type,
                    key: t.type
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.nodeProps.assignedType === 'ASSIGN_ORG')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_el_button, {
                    size: "default",
                    icon: "Plus",
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.orgPickerOpen(true))),
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_picker_items, {
                    modelValue: _ctx.nodeProps.assignedOrg,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nodeProps.assignedOrg) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : (_ctx.nodeProps.assignedType === 'ASSIGN_DEPT')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_el_button, {
                      size: "default",
                      icon: "Plus",
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deptPickerOpen(true))),
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_picker_items, {
                      modelValue: _ctx.nodeProps.assignedDept,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nodeProps.assignedDept) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : (_ctx.nodeProps.assignedType === 'ASSIGN_USER')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_el_button, {
                        size: "default",
                        icon: "Plus",
                        type: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.userPickerOpen(true))),
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_picker_items, {
                        modelValue: _ctx.nodeProps.assignedUser,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nodeProps.assignedUser) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : (_ctx.nodeProps.assignedType === 'SELF_SELECT')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_el_radio_group, {
                          size: "default",
                          modelValue: _ctx.nodeProps.selfSelect.multiple,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nodeProps.selfSelect.multiple) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: false }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: true }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : (_ctx.nodeProps.assignedType === 'LEADER')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_el_divider),
                          _createVNode(_component_el_form_item, {
                            label: "指定主管",
                            prop: "text"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11,
                              _createVNode(_component_el_input_number, {
                                style: {"margin":"0 5px"},
                                min: 1,
                                max: 20,
                                step: 1,
                                size: "default",
                                modelValue: _ctx.nodeProps.leader.level,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nodeProps.leader.level) = $event))
                              }, null, 8, ["modelValue"]),
                              _hoisted_12,
                              _hoisted_13
                            ]),
                            _: 1
                          })
                        ]))
                      : (_ctx.nodeProps.assignedType === 'LEADER_TOP')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_el_divider),
                            _createVNode(_component_el_form_item, {
                              label: "审批终点",
                              prop: "text",
                              class: "approve-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio_group, {
                                  modelValue: _ctx.nodeProps.leaderTop.endCondition,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.nodeProps.leaderTop.endCondition) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio, { label: "TOP" }, {
                                      default: _withCtx(() => [
                                        _hoisted_15
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, { label: "LEAVE" }, {
                                      default: _withCtx(() => [
                                        _hoisted_16
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (_ctx.nodeProps.leaderTop.endCondition === 'LEAVE')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      _hoisted_18,
                                      _createVNode(_component_el_input_number, {
                                        min: 1,
                                        max: 20,
                                        step: 1,
                                        size: "default",
                                        modelValue: _ctx.nodeProps.leaderTop.endLevel,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.nodeProps.leaderTop.endLevel) = $event))
                                      }, null, 8, ["modelValue"]),
                                      _hoisted_19
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : (_ctx.nodeProps.assignedType === 'AREA_LEADER')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_el_divider),
                              _createVNode(_component_el_form_item, {
                                label: "指定区域负责人",
                                prop: "text"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_21,
                                  _createVNode(_component_el_input_number, {
                                    style: {"margin":"0 5px"},
                                    min: 1,
                                    max: 20,
                                    step: 1,
                                    size: "default",
                                    modelValue: _ctx.nodeProps.areaLeader.level,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nodeProps.areaLeader.level) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_22,
                                  _hoisted_23
                                ]),
                                _: 1
                              })
                            ]))
                          : (_ctx.nodeProps.assignedType === 'AREA_PROJECT_LEADER')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createVNode(_component_el_divider),
                                _createVNode(_component_el_form_item, {
                                  label: "指定区域负责人(设备)",
                                  prop: "text"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_25,
                                    _createVNode(_component_el_input_number, {
                                      style: {"margin":"0 5px"},
                                      min: 0,
                                      max: 20,
                                      step: 1,
                                      size: "default",
                                      modelValue: _ctx.nodeProps.areaProjectLeader.level,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.nodeProps.areaProjectLeader.level) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _hoisted_26,
                                    _hoisted_27
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "选择表单设备字段",
                                  prop: "text",
                                  class: "approve-end mt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      style: {"width":"80%"},
                                      size: "default",
                                      modelValue: _ctx.nodeProps.areaProjectLeader.formProject,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.nodeProps.areaProjectLeader.formProject) = $event)),
                                      placeholder: "请选择包含设备ID的表单项"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceForms, (op, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: index,
                                            label: op.title,
                                            value: op.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _hoisted_28
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (_ctx.nodeProps.assignedType === 'AREA_PROJECT_HANDLE')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createVNode(_component_el_divider),
                                  _createVNode(_component_el_form_item, {
                                    label: "指定区域处理人(设备)",
                                    prop: "text"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_30,
                                      _createVNode(_component_el_input_number, {
                                        style: {"margin":"0 5px"},
                                        min: 0,
                                        max: 20,
                                        step: 1,
                                        size: "default",
                                        modelValue: _ctx.nodeProps.areaProjectHandle.level,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.nodeProps.areaProjectHandle.level) = $event))
                                      }, null, 8, ["modelValue"]),
                                      _hoisted_31,
                                      _hoisted_32
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    label: "选择表单设备字段",
                                    prop: "text",
                                    class: "approve-end mt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        style: {"width":"80%"},
                                        size: "default",
                                        modelValue: _ctx.nodeProps.areaProjectHandle.formProject,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.nodeProps.areaProjectHandle.formProject) = $event)),
                                        placeholder: "请选择包含设备ID的表单项"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceForms, (op, index) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: index,
                                              label: op.title,
                                              value: op.id
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]),
                                      _hoisted_33
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_ctx.nodeProps.assignedType === 'AREA_ORGCODE_LEADER')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createVNode(_component_el_divider),
                                    _createVNode(_component_el_form_item, {
                                      label: "指定区域负责人(组织)",
                                      prop: "text"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_35,
                                        _createVNode(_component_el_input_number, {
                                          style: {"margin":"0 5px"},
                                          min: 0,
                                          max: 20,
                                          step: 1,
                                          size: "default",
                                          modelValue: _ctx.nodeProps.areaOrgCodeLeader.level,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.nodeProps.areaOrgCodeLeader.level) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _hoisted_36,
                                        _hoisted_37
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "选择表单组织字段",
                                      prop: "text",
                                      class: "approve-end mt-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          style: {"width":"80%"},
                                          size: "default",
                                          modelValue: _ctx.nodeProps.areaOrgCodeLeader.formOrgCode,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.nodeProps.areaOrgCodeLeader.formOrgCode) = $event)),
                                          placeholder: "请选择包含组织代码的表单项"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceForms, (op, index) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: index,
                                                label: op.title,
                                                value: op.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"]),
                                        _hoisted_38
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_ctx.nodeProps.assignedType === 'AREA_ORGCODE_HANDLE')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createVNode(_component_el_divider),
                                      _createVNode(_component_el_form_item, {
                                        label: "指定区域处理人(组织)",
                                        prop: "text"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_40,
                                          _createVNode(_component_el_input_number, {
                                            style: {"margin":"0 5px"},
                                            min: 0,
                                            max: 20,
                                            step: 1,
                                            size: "default",
                                            modelValue: _ctx.nodeProps.areaOrgCodeHandle.level,
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.nodeProps.areaOrgCodeHandle.level) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _hoisted_41,
                                          _hoisted_42
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, {
                                        label: "选择表单组织字段",
                                        prop: "text",
                                        class: "approve-end mt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            style: {"width":"80%"},
                                            size: "default",
                                            modelValue: _ctx.nodeProps.areaOrgCodeHandle.formOrgCode,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.nodeProps.areaOrgCodeHandle.formOrgCode) = $event)),
                                            placeholder: "请选择包含组织代码的表单项"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceForms, (op, index) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: index,
                                                  label: op.title,
                                                  value: op.id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"]),
                                          _hoisted_43
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : (_ctx.nodeProps.assignedType === 'FORM_USER')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _createVNode(_component_el_form_item, {
                                          label: "选择表单联系人项",
                                          prop: "text",
                                          class: "approve-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              style: {"width":"80%"},
                                              size: "default",
                                              modelValue: _ctx.nodeProps.formUser,
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.nodeProps.formUser) = $event)),
                                              placeholder: "请选择包含联系人的表单项"
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (op, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    label: op.title,
                                                    value: op.id
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        _createVNode(_component_el_form_item, {
          label: "👤 审批人为空时",
          prop: "text",
          class: "line-mode"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.nodeProps.nobody.handler,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.nodeProps.nobody.handler) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "TO_PASS" }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "TO_REFUSE" }, {
                  default: _withCtx(() => [
                    _hoisted_49
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "TO_ADMIN" }, {
                  default: _withCtx(() => [
                    _hoisted_50
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "TO_USER" }, {
                  default: _withCtx(() => [
                    _hoisted_51
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.nodeProps.nobody.handler === 'TO_USER')
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode(_component_el_button, {
                    size: "default",
                    icon: "Plus",
                    type: "primary",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.noUserPickerOpen(false))),
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_53
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_picker_items, {
                    modelValue: _ctx.nodeProps.nobody.assignedUser,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.nodeProps.nobody.assignedUser) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.showMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _createVNode(_component_el_divider),
              _createVNode(_component_el_form_item, {
                label: "👩‍👦‍👦 多人审批时审批方式",
                prop: "text",
                class: "approve-mode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.nodeProps.mode,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.nodeProps.mode) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: "NEXT" }, {
                        default: _withCtx(() => [
                          _hoisted_55
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "AND" }, {
                        default: _withCtx(() => [
                          _hoisted_56
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "OR" }, {
                        default: _withCtx(() => [
                          _hoisted_57
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_divider, null, {
          default: _withCtx(() => [
            _hoisted_58
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "✍ 审批同意时是否需要签字",
          prop: "text"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              "inactive-text": "不用",
              "active-text": "需要",
              modelValue: _ctx.nodeProps.sign,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.nodeProps.sign) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_tooltip, {
              class: "item",
              effect: "dark",
              content: "如果全局设置了需要签字，则此处不生效",
              placement: "top-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"margin-left":"10px","font-size":"medium","color":"#b0b0b1"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "⏱ 审批期限（为 0 则不生效）",
          prop: "timeLimit"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              style: {"width":"180px"},
              placeholder: "时长",
              size: "small",
              type: "number",
              modelValue: _ctx.nodeProps.timeLimit.timeout.value,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.nodeProps.timeLimit.timeout.value) = $event))
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"75px"},
                  modelValue: _ctx.nodeProps.timeLimit.timeout.unit,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.nodeProps.timeLimit.timeout.unit) = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "天",
                      value: "D"
                    }),
                    _createVNode(_component_el_option, {
                      label: "小时",
                      value: "H"
                    }),
                    _createVNode(_component_el_option, {
                      label: "分钟",
                      value: "M"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.nodeProps.timeLimit.timeout.value > 0)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "审批期限超时后执行",
              prop: "level"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.nodeProps.timeLimit.handler.type,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.nodeProps.timeLimit.handler.type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "PASS" }, {
                      default: _withCtx(() => [
                        _hoisted_59
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "REFUSE" }, {
                      default: _withCtx(() => [
                        _hoisted_60
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "NOTIFY" }, {
                      default: _withCtx(() => [
                        _hoisted_61
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.nodeProps.timeLimit.handler.type === 'NOTIFY')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _hoisted_63,
                      _createVNode(_component_el_switch, {
                        "inactive-text": "循环",
                        "active-text": "一次",
                        modelValue: _ctx.nodeProps.timeLimit.handler.notify.once,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.nodeProps.timeLimit.handler.notify.once) = $event))
                      }, null, 8, ["modelValue"]),
                      (!_ctx.nodeProps.timeLimit.handler.notify.once)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                            _hoisted_65,
                            _createVNode(_component_el_input_number, {
                              min: 0,
                              max: 10000,
                              step: 1,
                              size: "default",
                              modelValue: _ctx.nodeProps.timeLimit.handler.notify.hour,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.nodeProps.timeLimit.handler.notify.hour) = $event))
                            }, null, 8, ["modelValue"]),
                            _hoisted_66
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, { label: "🙅‍ 如果审批被驳回 👇" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.nodeProps.refuse.type,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.nodeProps.refuse.type) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "TO_END" }, {
                  default: _withCtx(() => [
                    _hoisted_67
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "TO_BEFORE" }, {
                  default: _withCtx(() => [
                    _hoisted_68
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "TO_NODE" }, {
                  default: _withCtx(() => [
                    _hoisted_69
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.nodeProps.refuse.type === 'TO_NODE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _hoisted_71,
                  _createVNode(_component_el_select, {
                    style: {"margin-left":"10px","width":"150px"},
                    placeholder: "选择跳转步骤",
                    size: "small",
                    modelValue: _ctx.nodeProps.refuse.target,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.nodeProps.refuse.target) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodeOptions, (node, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: i,
                          label: node.name,
                          value: node.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_org_picker, {
      ref: "orgPicker",
      multiple: _ctx.orgMultiple,
      selected: _ctx.assignedOrg,
      onOk: _ctx.orgSelected
    }, null, 8, ["multiple", "selected", "onOk"]),
    _createVNode(_component_dept_picker, {
      ref: "deptPicker",
      multiple: _ctx.deptMultiple,
      selected: _ctx.assignedDept,
      onOk: _ctx.deptSelected
    }, null, 8, ["multiple", "selected", "onOk"]),
    _createVNode(_component_post_picker, {
      ref: "postPicker",
      multiple: _ctx.postMultiple,
      selected: _ctx.assignedPost,
      onOk: _ctx.postSelected
    }, null, 8, ["multiple", "selected", "onOk"]),
    _createVNode(_component_user_picker, {
      ref: "userPicker",
      multiple: _ctx.userMultiple,
      selected: _ctx.assignedUser,
      onOk: _ctx.userSelected
    }, null, 8, ["multiple", "selected", "onOk"]),
    _createVNode(_component_user_picker, {
      ref: "noUserPicker",
      multiple: _ctx.noUserMultiple,
      selected: _ctx.assignedNoUser,
      onOk: _ctx.noUserSelected
    }, null, 8, ["multiple", "selected", "onOk"])
  ]))
}